import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { setView, ViewName } from '../../../../slices/TicketDetailUISlice';
import { useReduxDispatch, useReduxSelector } from '../../../../redux/hooks';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';
import { isMobile } from 'react-device-detect';
import { FileApi } from '../../../../redux/api/FileApi';
import { useParams } from 'react-router-dom';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import { useCurrentUserContext } from '../../../../context/UserContext';


const ActionTabs: React.FC<ITicketProps> = (props) => {
    const { ticketId } = useParams();
    const dispatch = useReduxDispatch();
    const selectedView = useReduxSelector(state => state.ticketDetailsUI.viewName);
    const { data: ticketFiles, isFetching: fetchingTicektFiles } = FileApi.useGetTicketFilesQuery({ ticketId: parseInt(ticketId) })

    const handleSelect = (view: ViewName) => {
        dispatch(setView(view));
    };

    const { profile: userProfile } = useCurrentUserContext();
    if (userProfile?.Features.External_Interface || false || (!userProfile?.Features.AI_Summary && !userProfile?.Features.Call_History_Timeline)) return <div className='mt-2'></div>;

    return (
        <Tabs
            id="action-tabs"
            activeKey={selectedView}
            onSelect={(k) => handleSelect((k || 'notes') as ViewName)}
            className={' mt-2 justify-content-end flex ' + (isMobile ? ' mobile-tabs' : 'action-tabs')}
        >

            {isMobile && <Tab eventKey="notes" title={<>Notes</>}></Tab>}
            {isMobile && <Tab eventKey="details" title={<>Details</>}> </Tab>}
            {isMobile && <Tab eventKey="status" title={<>Status</>}> </Tab>}
            {isMobile && <Tab eventKey="ownership" title={props?.Is_Workstream ? <>Allocation</> : <>Ownership</>}> </Tab>}
            {isMobile && ticketFiles?.length > 0 && <Tab eventKey="attach" title={<><SvgIcon icon={svg.paperclipIcon} className='m-1' /></>}> </Tab>}

            {!isMobile && <Tab eventKey="notes" title={<><SvgIcon icon={svg.stickyNoteIcon} className='m-1' />Notes</>}>
            </Tab>}
            {
                userProfile?.Features.Call_History_Timeline && !isMobile && <Tab eventKey="timeline" title={<><img className='story-line' src='./images/toolbar/storyline.png' />Storyline</>}>
                </Tab>
            }
            {
                userProfile?.Features.AI_Summary && !isMobile && <Tab tabClassName='ai-tab' eventKey="summary" title={<><SvgIcon icon={svg.sparklesIcon} className='m-1' />AI Summary</>}>
                </Tab>
            }

        </Tabs >
    );
};

export default ActionTabs;